<template>
    <v-row justify="center">
        <v-dialog max-width="500px" persistent v-model="showPopup.show">
            <v-form ref="form">
                <v-card>
                    <v-card-title class="blue" primary-title>
                        <v-icon class="pa-1 mr-1" color="blue darken-4">fas fa-reply-all</v-icon>
                        <span>Ersetzen</span>
                    </v-card-title>
                    <v-card-text class="headline ma-1">
                        Bestätigen Sie den Vorgang
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn @click="showPopup.show = false" color="blue darken-1" text>Nein</v-btn>
                        <v-btn :loading="loading" @click="submit" color="green darken-1" text>Ja</v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>

    </v-row>
</template>

<script>
    import {HTTP} from "../http";
    import {EventBus} from "../eventbus";


    export default {
        props: {
            showPopup: Object,
            LicenceId: String
        },
        data() {
            return {
                loading: false,
            }
        },
        methods: {
            submit() {
                if (this.$refs.form.validate()) {
                    this.loading = true;
                    let data = {
                        LicenceID: this.LicenceId
                    }
                    HTTP.post("api/Licence/replace", data).then(() => {
                        this.loading = false;
                        EventBus.$emit('reload');
                        this.showPopup.show = false;
                    }).catch(() => {
                        this.loading = false;
                    })

                }
            }
        }
    }
</script>
